'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var VALUE_CELL = exports.VALUE_CELL = 'value';
var SUB_TOTAL_CELL = exports.SUB_TOTAL_CELL = 'valueSubtotals';
var TOTAL_CELL = exports.TOTAL_CELL = 'valueTotal';
var DIMENSION_CELL = exports.DIMENSION_CELL = 'dimension';
var DIMENSION_SUB_TOTAL_CELL = exports.DIMENSION_SUB_TOTAL_CELL = 'dimensionSubtotal';
var DIMENSION_TOTAL_CELL = exports.DIMENSION_TOTAL_CELL = 'dimensionTotal';
var EMPTY_CELL = exports.EMPTY_CELL = 'empty';
var LABELED_CELL = exports.LABELED_CELL = 'labeled';
var PADDING_CELL = exports.PADDING_CELL = 'padding';
var FILTER_CELL = exports.FILTER_CELL = 'filter';

var TOTAL_SORT = exports.TOTAL_SORT = 'total';

var COLUMN_AXIS = exports.COLUMN_AXIS = 'column';
var ROW_AXIS = exports.ROW_AXIS = 'row';

var FIXED_STRATEGY = exports.FIXED_STRATEGY = 'fixed';
var BY_DATA_ITEM_STRATEGY = exports.BY_DATA_ITEM_STRATEGY = 'by_data_item';

var FILL_STYLE = exports.FILL_STYLE = 'fill';
var TEXT_STYLE = exports.TEXT_STYLE = 'text';

var NO_BREAK_SPACE = exports.NO_BREAK_SPACE = '&nbsp;';

var BLACK_COLOR = exports.BLACK_COLOR = 'black';
var WHITE_COLOR = exports.WHITE_COLOR = 'white';

var AVERAGE_AGGREGATION_TOTAL = exports.AVERAGE_AGGREGATION_TOTAL = 'AVERAGE';
var SUM_AGGREGATION_TOTAL = exports.SUM_AGGREGATION_TOTAL = 'SUM';
var NA_AGGREGATION_TOTAL = exports.NA_AGGREGATION_TOTAL = 'N/A';

var DEFAULT_NUMBER_DECIMALS = exports.DEFAULT_NUMBER_DECIMALS = 1;
var SMALL_NUMBER_DECIMALS = exports.SMALL_NUMBER_DECIMALS = 2;
var SKIP_ROUNDING_NUMBER_DECIMALS = exports.SKIP_ROUNDING_NUMBER_DECIMALS = 10;

var NUMBER_VALUE_TYPE = exports.NUMBER_VALUE_TYPE = 'NUMBER';
var BOOLEAN_VALUE_TYPE = exports.BOOLEAN_VALUE_TYPE = 'BOOLEAN';
var DATE_VALUE_TYPE = exports.DATE_VALUE_TYPE = 'DATE';
var FILE_RESOURCE_VALUE_TYPE = exports.FILE_RESOURCE_VALUE_TYPE = 'FILE_RESOURCE';
var COORDINATE_VALUE_TYPE = exports.COORDINATE_VALUE_TYPE = 'COORDINATE';
var TEXT_VALUE_TYPE = exports.TEXT_VALUE_TYPE = 'TEXT';

var PIVOT_TABLE_CELLS = exports.PIVOT_TABLE_CELLS = {
    VALUE_CELL: VALUE_CELL,
    SUB_TOTAL_CELL: SUB_TOTAL_CELL,
    TOTAL_CELL: TOTAL_CELL,
    DIMENSION_CELL: DIMENSION_CELL,
    DIMENSION_SUB_TOTAL_CELL: DIMENSION_SUB_TOTAL_CELL,
    DIMENSION_TOTAL_CELL: DIMENSION_TOTAL_CELL,
    EMPTY_CELL: EMPTY_CELL,
    LABELED_CELL: LABELED_CELL,
    PADDING_CELL: PADDING_CELL,
    FILTER_CELL: FILTER_CELL
};

var PIVOT_TABLE_AXIS = exports.PIVOT_TABLE_AXIS = {
    COLUMN_AXIS: COLUMN_AXIS,
    ROW_AXIS: ROW_AXIS
};

var PIVOT_TABLE_SORT_OPTIONS = exports.PIVOT_TABLE_SORT_OPTIONS = {
    TOTAL_SORT: TOTAL_SORT
};

var PIVOT_TABLE_LEGEND_SET_OPTIONS = exports.PIVOT_TABLE_LEGEND_SET_OPTIONS = {
    FIXED_STRATEGY: FIXED_STRATEGY,
    BY_DATA_ITEM_STRATEGY: BY_DATA_ITEM_STRATEGY,
    FILL_STYLE: FILL_STYLE,
    TEXT_STYLE: TEXT_STYLE
};

var PIVOT_TABLE_HTML = exports.PIVOT_TABLE_HTML = {
    NO_BREAK_SPACE: NO_BREAK_SPACE
};

exports.default = {
    VALUE_CELL: VALUE_CELL,
    SUB_TOTAL_CELL: SUB_TOTAL_CELL,
    TOTAL_CELL: TOTAL_CELL,
    DIMENSION_CELL: DIMENSION_CELL,
    DIMENSION_SUB_TOTAL_CELL: DIMENSION_SUB_TOTAL_CELL,
    DIMENSION_TOTAL_CELL: DIMENSION_TOTAL_CELL,
    EMPTY_CELL: EMPTY_CELL,
    LABELED_CELL: LABELED_CELL,
    PADDING_CELL: PADDING_CELL,
    FILTER_CELL: FILTER_CELL,
    TOTAL_SORT: TOTAL_SORT,
    COLUMN_AXIS: COLUMN_AXIS,
    ROW_AXIS: ROW_AXIS,
    FIXED_STRATEGY: FIXED_STRATEGY,
    BY_DATA_ITEM_STRATEGY: BY_DATA_ITEM_STRATEGY,
    FILL_STYLE: FILL_STYLE,
    TEXT_STYLE: TEXT_STYLE,
    NO_BREAK_SPACE: NO_BREAK_SPACE
};
//# sourceMappingURL=PivotTableConstants.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/lib/table/PivotTableConstants.js
 ** module id = 17
 ** module chunks = 0 1
 **/